export default __webpack_public_path__ + "static/media/later-funding.c5b800e4.svg";